/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

import Feathers from "@feathersjs/feathers";

import { Autobind } from "@Internal/Utils";
import { CustomError } from "@Internal/Models";

import { PriceAudit } from "App/Models";

import { ProcessException } from "./Base";

/* Read-side for the price change history. The backend returns plain JSON audit rows
   (Action, Field, OldValue, NewValue, Actor, CreatedAt), consumed as-is. */
export default class PriceAuditService {
    private findService: Feathers.Service<any>;

    constructor( findService: Feathers.Service<any> ) {
        this.findService = findService;
    }

    @Autobind
    async FindByPrice( priceId: number ): Promise<[ PriceAudit[], CustomError | undefined ]> {
        return this.find( { PriceId: priceId } );
    }

    /* Whole-plan history: every price of the plan, including ones since deleted. */
    @Autobind
    async FindByPlan( planId: number ): Promise<[ PriceAudit[], CustomError | undefined ]> {
        return this.find( { PlanId: planId } );
    }

    private async find(
        query: Record<string, number>
    ): Promise<[ PriceAudit[], CustomError | undefined ]> {
        try {
            const results = await this.findService.find( { query } );

            /* The global serialization after-hook reshapes `{ Records, PagerSorter }` into
               `{ Items, Pagination }`, so read `Items` (keep `Records` as a defensive fallback). */
            const records = ( results !== undefined && results.Items !== undefined )
                ? results.Items
                : ( results !== undefined && results.Records !== undefined )
                    ? results.Records
                    : [];

            return [ records as PriceAudit[], undefined ];

        } catch( error ) {
            return [ [], await ProcessException( error ) ];
        }
    }
}
